import CarotekColors from "@carotek/utils/Colors";
import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

Object.assign(categoryDetailSubCategoriesStyles, {
    ...categoryDetailSubCategoriesStyles,
    container: {
        gap: 15,
    },
    subCategoryItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            padding-bottom: 10px;
        `,
    },
    innerContainer: {
        gap: 0,
        css: css`
            border: 1px solid ${CarotekColors.grey5};
            background: ${CarotekColors.white};
            padding-top: 5px;
        `,
    },
    subCategoryImageItem: {
        width: 12,
        css: css`
            width: 100%;
            padding: 0 8px 8px 8px;
            min-height: 182px;
            padding-bottom: 0;
        `,
    },
    subCategoryImageClickable: {
        css: css`
            width: 100%;
        `,
    },
    subCategoryImage: {
        css: css`
            [class^="LazyImageStyle"] {
                margin: 0 auto;
            }
            img {
                height: 100%;
                max-height: 182px;
            }
        `,
    },
    subCategoryNameLinkItem: {
        width: 12,
        css: css`
            padding-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                    css`
                        justify-content: flex-start;
                    `,
                ])}
        `,
    },
    subCategoryNameLink: {
        css: css`
            width: 100%;
            margin: 20px 0;
        `,
        color: "text.link",
        typographyProps: {
            weight: "bold",
            size: 16,
            color: "text.link",
            fontFamily: "OpenSansBold",
            css: css`
                width: 100%;
                text-align: center;
                word-wrap: break-word;
                :hover {
                    text-decoration: underline;
                }
            `,
        },
    },
});
